import { createActions } from "direct-vuex";
import Axios, { AxiosResponse } from "axios";
import config from "@/config";
import { sessionActionContext } from ".";
import {
  LoginResponse,
  LoginPayload,
  MeResponse,
  ValidatePayload
} from "./types";

const path = config.hostname + "/sessions/";
const validatePath = config.hostname + "/users/";

export default createActions({
  async login(context, credentials: { email: string; password: string }) {
    const { commit, rootCommit } = sessionActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<LoginResponse> = await Axios.post<
        LoginResponse
      >(path, { session: credentials });
      if (result.data.user.data.attributes.validated) {
        commit.SET_TOKEN(result.data.token);
        commit.SET_USER(result.data.user.data);
        if (!result.data.user.data.attributes.is_admin) {
          commit.SET_WELCOME(true);
        }
      }
      rootCommit.END_LOADING();
      return { data: result.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async reset(context, email: string) {
    const { commit, rootCommit } = sessionActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse = await Axios.post(path + "reset_password", {
        email: email
      });
      rootCommit.END_LOADING();
      return { data: result.data };
    } catch (error) {
      console.log(error);
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async me(context) {
    const { commit, rootCommit } = sessionActionContext(context);
    try {
      rootCommit.START_LOADING();
      let result: AxiosResponse<MeResponse> = await Axios.get<MeResponse>(path);
      commit.SET_USER(result.data.data);
      rootCommit.END_LOADING();
      return { data: result.data.data };
    } catch (error) {
      console.log(error);
      commit.LOGOUT();
      rootCommit.END_LOADING();
      return { error };
    }
  },
  async validate(
    context,
    attrs: { id: string; token: string; payload: ValidatePayload }
  ) {
    const { commit, rootCommit } = sessionActionContext(context);
    try {
      rootCommit.START_LOADING();
      commit.SET_TOKEN(attrs.token);
      let result: AxiosResponse<MeResponse> = await Axios.put<MeResponse>(
        validatePath + attrs.id + "/validate",
        attrs.payload
      );
      commit.SET_USER(result.data.data);
      if (!result.data.data.attributes.is_admin) {
        commit.SET_WELCOME(true);
      }
      rootCommit.END_LOADING();
      return { data: result.data.data };
    } catch (error) {
      console.log(error);
      commit.LOGOUT();
      rootCommit.END_LOADING();
      return { error };
    }
  }
});
